import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {Sector, SectorInput} from './sector.model';

export const loadSectors = createAction(
  '[Sector/API] Load Sectors',
  props<{ sectors: Sector[] }>()
);

export const addSector = createAction(
  '[Sector/API] Add Sector',
  props<{ sector: Sector }>()
);

export const upsertSector = createAction(
  '[Sector/API] Upsert Sector',
  props<{ sector: Sector }>()
);

export const addSectors = createAction(
  '[Sector/API] Add Sectors',
  props<{ sectors: Sector[] }>()
);

export const upsertSectors = createAction(
  '[Sector/API] Upsert Sectors',
  props<{ sectors: Sector[] }>()
);

export const updateSector = createAction(
  '[Sector/API] Update Sector',
  props<{ sector: Update<Sector> }>()
);

export const updateSectors = createAction(
  '[Sector/API] Update Sectors',
  props<{ sectors: Update<Sector>[] }>()
);

export const deleteSector = createAction(
  '[Sector/API] Delete Sector',
  props<{ id: string }>()
);

export const deleteSectors = createAction(
  '[Sector/API] Delete Sectors',
  props<{ ids: string[] }>()
);

export const clearSectors = createAction(
  '[Sector/API] Clear Sectors'
);

// CUSTOM ACTIONS
export const createInstitutionSectorMutation = createAction(
  '[Sector/API] Create Sector',
  props<{ input:SectorInput }>()
);

export const updateInstitutionSectorMutation = createAction(
  '[Sector/API] update Institution Sector Mutation',
  props<{ input:SectorInput }>()
);

export const getAllSectors = createAction(
  '[Sector/API] Get All Sectors',
  props<{ filtering:{searchTerm:null} }>()
);

export const removeSector = createAction(
  '[Sector/API] Remove Sector',
  props<{ sectorUniqueId: string, id: string }>()
);
